<template>
    <div class="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div class="sm:mx-auto sm:w-full sm:max-w-md">
            <router-link to="/login">
                <img class="mx-auto h-10 w-auto" src="/images/logo.webp" alt="Beckmann Systemlogistik" />
            </router-link>
            <h2 class="mt-6 text-center text-2xl font-semibold tracking-tight text-gray-900">Passwort zurücksetzen</h2>
            <p class="mt-2 text-center text-sm text-gray-500">
                Gib deinen Benutzernamen oder deine E-Mail ein.
            </p>
        </div>

        <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div class="bg-white py-8 px-6 shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl sm:px-10">
                <form @submit.prevent="submitForm" class="space-y-5">
                    <div>
                        <label for="username" class="block text-sm font-medium text-gray-700">Benutzername oder E-Mail</label>
                        <div class="mt-1.5">
                            <input v-model="form.username" id="username" name="text" type="text"
                                   autocomplete="email" required
                                   placeholder="name@firma.de"
                                   class="block w-full rounded-md border-gray-300 px-3.5 py-2 text-gray-900 shadow-sm placeholder:text-gray-400 focus:border-secondary focus:ring-secondary sm:text-sm" />
                        </div>
                    </div>

                    <button type="submit" :disabled="loading"
                            class="flex w-full justify-center rounded-md bg-primary px-4 py-2.5 text-sm font-medium text-white shadow-sm hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                        <span v-if="loading">Bitte warten...</span>
                        <span v-else>Passwort zurücksetzen</span>
                    </button>

                    <div class="text-center">
                        <router-link to="/login" class="inline-flex items-center text-sm text-gray-500 hover:text-gray-700">
                            <ArrowLeftIcon class="h-3.5 mr-1" />
                            Zurück zum Login
                        </router-link>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { ArrowLeftIcon } from '@heroicons/vue/24/outline';

export default {
    components: {
        ArrowLeftIcon,
    },

    data() {
        return {
            loading: false,
            form: {
                username: '',
            },
        };
    },

    methods: {
        submitForm() {
            this.loading = true;
            axios.post('/api/forgot-password', this.form)
                .then((response) => {
                    this.$router.push('/login');
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>
